import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ResponseMetaData } from "../../entities/global";
import { getCasesBonuses, getCasesEntites, getCasesProfiles } from "./thunks";
import { CasesBonus, CasesEntity } from "../../entities/cases_v2";
import { FortuneWheelProfile } from "../../entities/wheelGame_v2";

interface CasesTableState {
  loading: boolean;
  meta: {
    bonuse: ResponseMetaData;
    entity: ResponseMetaData;
    profile: ResponseMetaData;
  };
  bonuses: CasesBonus[];
  entites: CasesEntity[];
  profiles: FortuneWheelProfile[];

  needUpdateBonuses: boolean;
  needUpdateEntites: boolean;
  needUpdateProfiles: boolean;
}

const initialState: CasesTableState = {
  loading: false,

  bonuses: [],
  entites: [],
  profiles: [],

  needUpdateBonuses: true,
  needUpdateEntites: true,
  needUpdateProfiles: true,

  meta: {
    bonuse: {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
    },
    entity: {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
    },
    profile: {
      limit: 250,
      page: 1,
      pages: 1,
      total: 0,
    },
  },
};

export const casesTableStore = createSlice({
  name: "cases",
  initialState: initialState,
  reducers: {
    handlerNeedUpdate: (
      state,
      action: PayloadAction<{
        key: "bonus" | "entity" | "profile";
        value: boolean;
      }>
    ) => {
      const { key, value } = action.payload;

      if (key === "bonus") state.needUpdateBonuses = value;
      if (key === "entity") state.needUpdateEntites = value;
      if (key === "profile") state.needUpdateProfiles = value;
    },
  },
  extraReducers: (builder) => {
    // getCasesBonuses
    builder.addCase(getCasesBonuses.pending, (state) => {
      state.loading = true;
      state.needUpdateBonuses = false
    })
    builder.addCase(getCasesBonuses.fulfilled, (state, action) => {
      const { data, ...meta } = action.payload
      state.bonuses = data;
      state.meta.bonuse = meta

      state.loading = false
    })
    // getWheelProfiles
    builder.addCase(getCasesProfiles.pending, (state) => {
      state.loading = true;
      state.needUpdateProfiles = false;
    })
    builder.addCase(getCasesProfiles.fulfilled, (state, action) => {
      const { data, ...meta } = action.payload;
      state.profiles = data;
      state.meta.profile = meta;

      state.loading = false;
    })
    // getWheelEntites
    builder.addCase(getCasesEntites.pending, (state) => {
      state.loading = true;
      state.needUpdateEntites = false;
    })
    builder.addCase(getCasesEntites.fulfilled, (state, action) => {
      const { data, ...meta } = action.payload;
      state.entites = data;
      state.meta.entity = meta;

      state.loading = false;
    })
  },
});

export const { handlerNeedUpdate } = casesTableStore.actions;

export default casesTableStore.reducer;
